<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div v-if="detail != null">
          <jr-applicant-title
            titleName="事前調査結果"
            :applicantNumber="detail.applicant_number"
            :applicantTitle="detail.applicant_title"
          />
        </div>
      </template>
      <template #default>
        <double-scroll>
          <template #left>
            <boundary-info v-if="requestHeaderId" :requestHeaderId="requestHeaderId" @update:form="detail = $event" />
          </template>
          <template #right>
            <div class="double-scroll-padding">
              <input-group-dark :title="route.meta.title" class="input-group-dark-margin">
                <boundary-result
                  :isEdit="false"
                  :disabled="true"
                  :requestHeaderId="requestHeaderId"
                  :boundaryResultType="BoundaryResultType.PRELIMINARYSURVEY"
                  :messageId="messageId"
                />
              </input-group-dark>
            </div>
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import InputGroupDark from '@/components/layout/InputGroupDark.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import BoundaryInfo from '@/components/layout/BoundaryInfo.vue'
import BoundaryResult from '@/components/layout/BoundaryResult.vue'
import { useRoute, useRouter } from 'vue-router'
import Logger from '@/services/logger'
import { RequestHeaderProximityForm } from '@/types/forms'
import { BoundaryResultType } from '@/constants/enums'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'

export default defineComponent({
  components: {
    InputGroupDark,
    UserLoginWrapper,
    BoundaryInfo,
    BoundaryResult,
    DoubleScroll,
    JrApplicantTitle,
  },
  setup() {
    // 初期値を設定
    const route = useRoute()
    const router = useRouter()
    const detail = ref<RequestHeaderProximityForm | null>(null)
    const requestHeaderId = computed(() => {
      return Number(route.params.request_header_id)
    })

    const messageId = computed(() => {
      return Number(route.params.message_id)
    })

    //申請基本IDが正しくない場合404へ飛ばす
    if (Number.isNaN(requestHeaderId.value)) {
      Logger.info('申請基本IDが正しくない')
      router.push({ name: 'NotFound' })
    }

    //メッセージIDが正しくない場合404へ飛ばす
    if (Number.isNaN(messageId.value)) {
      Logger.info('メッセージIDが正しくない')
      router.push({ name: 'NotFound' })
    }

    return {
      route,
      detail,
      requestHeaderId,
      BoundaryResultType,
      messageId,
    }
  },
})
</script>

<style lang="scss" scoped>
.input-group-dark-margin {
  margin-bottom: 50px;
}
</style>
